import React from 'react'

export default function Stats({ stats }) {
    return (
        <div className='grid gap-30 max-1400 ma p10 m-wlbb1'>
            {stats.map(({ title, figure },index) => {
                return (
                    <div key={index} className='flex flex-col pt10 pb60 bt1 bb1 m-bb0 m-pb10'>
                        <div className='mb160 m-mb40 text-light'>{title}</div>
                        <div className='h5 text-light'>{figure}</div>
                    </div>
                )
            })}
        </div>
    )
}
